import env from './environment'

export default env
